// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/settings/WidgetsSettingsView/widgets.css
// module id = 1905
// module chunks = 0